import { useTranslation } from "react-i18next";
import { Rocket, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CTASection() {
  const { t } = useTranslation();
  const handleRedirect = () => {
    window.open("https://www.realtyblocks.com", "_blank");
  };

  return (
    <section className="relative section overflow-hidden">
      {/* Layered backdrop */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-[hsl(var(--brand-navy))]" aria-hidden="true" />
      <div className="absolute inset-0 opacity-40 mix-blend-soft-light"
           style={{ backgroundImage: "radial-gradient(circle at 20% 0%, hsl(var(--accent)) 0px, transparent 40%), radial-gradient(circle at 80% 100%, hsl(var(--brand-teal)) 0px, transparent 45%)" }}
           aria-hidden="true" />
      <div className="absolute inset-0 opacity-[0.04]"
           style={{ backgroundImage: "linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)", backgroundSize: "32px 32px" }}
           aria-hidden="true" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
        <h2 className="font-display text-display-xl mb-5">
          {t("cta.title")}
        </h2>
        <p className="text-base sm:text-xl mb-10 sm:mb-12 opacity-90 max-w-2xl mx-auto leading-relaxed">
          {t("cta.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 mb-12">
          <Button
            onClick={handleRedirect}
            variant="accent"
            size="xl"
            className="w-full sm:w-auto"
            data-testid="button-start-journey"
          >
            <Rocket className="h-5 w-5" />
            {t("cta.startJourney")}
          </Button>
          <Button
            onClick={handleRedirect}
            size="xl"
            variant="outline"
            className="w-full sm:w-auto bg-transparent border-2 border-white/40 text-white hover:bg-white hover:text-primary hover:border-white"
            data-testid="button-schedule-demo"
          >
            <Phone className="h-4 w-4" />
            {t("cta.scheduleDemo")}
          </Button>
        </div>

        <div className="grid grid-cols-3 gap-4 sm:gap-8 text-center">
          {[
            { value: "10,000+", label: t("cta.statUsers"), testId: "stat-users" },
            { value: "₹500 Cr+", label: t("cta.statTransactions"), testId: "stat-transactions" },
            { value: "95%", label: t("cta.statSatisfaction"), testId: "stat-satisfaction" },
          ].map((s) => (
            <div key={s.testId} data-testid={s.testId} className="rounded-xl border border-white/15 bg-white/5 backdrop-blur-sm py-4 sm:py-5 px-2 sm:px-4">
              <div className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-1">{s.value}</div>
              <div className="text-[11px] sm:text-sm opacity-80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
